"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivableRepaymentsHistorySchema = void 0;
const zod_1 = require("zod");
const Utils_1 = require("./Utils");
// Zod schema for ReceivableRepaymentsHistory
exports.ReceivableRepaymentsHistorySchema = zod_1.z.object({
    normalizedRepaymentAmount: zod_1.z.number(),
    finleyRepaymentDate: Utils_1.ZodFullDateStrStruct,
});
// Note: Compile-time assertion is omitted for this type because ZodFullDateStrStruct
// produces a more specific type than FullDateStr template literal
//# sourceMappingURL=RepaymentEntry.js.map